import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle,
} from '@angular/material/expansion';

@Component({
  selector: 'app-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle],
})
export class AccordionComponent implements OnInit {
  @Input() list: any;
  collapsedHeight = '56px';
  expandedHeight = '56px';

  constructor() {}

  ngOnInit() {}
}
